import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { contains } from 'ramda';
import { simpleActionTypePrefix } from "./actionTypes";
var SimpleAction = /*#__PURE__*/_createClass(function SimpleAction(_ref) {
  var _this = this;
  var name = _ref.name,
    path = _ref.path,
    _ref$defaultState = _ref.defaultState,
    defaultState = _ref$defaultState === void 0 ? {} : _ref$defaultState,
    _ref$dispatches = _ref.dispatches,
    dispatches = _ref$dispatches === void 0 ? ['set', 'update', 'reset'] : _ref$dispatches;
  _classCallCheck(this, SimpleAction);
  this.name = name;
  this.defaultState = defaultState;
  this.path = path;
  this.types = {};
  ['set', 'reset', 'update'].forEach(function (subaction) {
    if (contains(subaction, dispatches)) {
      var type = "".concat(simpleActionTypePrefix, " ").concat(name, " ").concat(subaction);
      _this[subaction] = function (arg) {
        return {
          type: type,
          payload: arg
        };
      };
      _this.types[subaction] = type;
    } else {
      _this[subaction] = function () {
        return {
          type: "".concat(simpleActionTypePrefix, " error"),
          error: true,
          payload: "".concat(subaction, " not allowed for ").concat(name)
        };
      };
    }
  });
});
export var createSimpleAction = function createSimpleAction(options) {
  return new SimpleAction(options);
};